import { create } from 'zustand';
import * as rantingService from '../services/rantingService'; // Asumsi ada rantingService

const useRantingTransactionStore = create((set, get) => ({
  transactions: [],
  loading: false,
  error: null,

  fetchTransactions: async () => {
    set({ loading: true, error: null });
    try {
      const data = await rantingService.getRantingTransactions();
      set({ transactions: data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  addPenerimaanInfak: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await rantingService.createPenerimaanInfak(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  addPenerimaanDanaAmil: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await rantingService.createPenerimaanDanaAmil(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  addPenerimaanZakat: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await rantingService.createPenerimaanZakat(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  addPenyaluran: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await rantingService.createPenyaluran(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  addBebanPengelolaan: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await rantingService.createBebanPengelolaan(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  updateTransaction: async (id, transactionData) => {
    set({ loading: true, error: null });
    try {
      await rantingService.updateRantingTransaction(id, transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  removeTransaction: async (id) => {
    set({ loading: true, error: null });
    try {
      await rantingService.deleteRantingTransaction(id);
      set((state) => ({
        transactions: state.transactions.filter((t) => t.id !== id),
        loading: false,
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },
}));

export default useRantingTransactionStore;